import { render, staticRenderFns } from "./AddressSelectorView.vue?vue&type=template&id=5215dc2e&"
import script from "./AddressSelectorView.vue?vue&type=script&lang=js&"
export * from "./AddressSelectorView.vue?vue&type=script&lang=js&"
import style0 from "./AddressSelectorView.vue?vue&type=style&index=0&id=5215dc2e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports